import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C, ModuleFE_Thunderstorm, SimpleListAdapter, TS_DropDown, TS_Tabs } from '@nu-art/thunderstorm-frontend/index';
import { DataGrid } from '@app/styles';
import './OrderItem_EditorRenderer.scss';
import { actionSubTypeLabelMap, ActionSubTypes_Interflow, ActionSubTypes_Order, ActionType_Order } from '@app/pathway-shared';
import { Renderer_ActionData_Order } from './data-renderers/Renderer_ActionData_Order.js';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText, DefaultEditor_InputText_Optional } from '@app/styles/frontend/ui-manager/ui-components';
import { Dropdown_ActionType } from '../../../../_entity/action/ui-components.js';
import { Renderer_ActionData_Uneditable } from './data-renderers/Renderer_ActionData_Uneditable.js';
import { PermissionKeyFE_DeveloperViewer } from '@nu-art/permissions-frontend/core/permission-keys';
import { PermissionsComponent } from '@nu-art/permissions-frontend/index';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { Renderer_OrderRulesEditor } from './data-renderers/order-rules-editor/Renderer_OrderRulesEditor.js';
import { Component_TagEditor, VariableWrapper } from '@app/hcs-frontend';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { ModuleFE_Action } from '../../../../_entity/action/index.js';
import { Component_TagGroups } from '@app/hcs-frontend/tag';
const RenderKey_Edit = 'edit';
const RenderKey_View = 'view';
export class OrderItem_EditorRenderer extends TS_EditableItemComponentProto {
    deriveStateFromProps(nextProps, state) {
        const prevId = state.editable?.item?._id;
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        if (prevId && (prevId !== state.editable.item._id))
            state.selectedTab = 'general-information';
        return state;
    }
    // ######################## Logic ########################
    getRenderKey = () => {
        return this.state.editMode ? RenderKey_Edit : RenderKey_View;
    };
    // ######################## Render ########################
    render() {
        return _jsx(LL_H_C, { className: 'match_parent', children: this.renderTabs() });
    }
    renderTabs = () => {
        return _jsx(TS_Tabs, { selectedTabId: this.state.selectedTab, onSelected: (selectedTabId) => this.setState({ selectedTab: selectedTabId }), tabs: [
                {
                    title: 'General Information',
                    content: this.renderBaseBody,
                    uid: 'general-information'
                },
                {
                    title: 'Order Variables',
                    content: () => _jsx(Renderer_OrderRulesEditor, { editable: this.state.editable, editMode: this.state.editMode }),
                    disabled: this.state.editable.item.type !== ActionType_Order || !this.state.editable.item.variableId,
                    uid: 'order-variable'
                },
                {
                    title: 'Order Demo Metadata',
                    content: this.renderDemoOrderMetadata,
                    uid: 'order-demo-metadata'
                },
            ] });
    };
    renderBaseBody = () => {
        return _jsxs(DataGrid.Grid, { className: 'editor__order', children: [this.renderName(), this.renderLabel(), _jsx(PermissionsComponent, { permissionKey: PermissionKeyFE_DeveloperViewer, children: this.renderOrderId() }), this.renderType(), this.renderSubType(), this.renderData(), this.renderTags()] });
    };
    renderDemoOrderMetadata = () => {
        return _jsx(PermissionsComponent, { permissionKey: PermissionKeyFE_DeveloperViewer, children: _jsx(Renderer_ActionData_Uneditable, { editable: this.state.editable }) });
    };
    renderName = () => {
        const action = this.state.editable;
        const actionName = action.item.name ?? '-';
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Order Name" }), _jsx(Component_SwitchView, { mode: this.getRenderKey(), modes: [
                        {
                            key: RenderKey_View,
                            renderer: () => _jsx(DataGrid.Data, { onClick: () => ModuleFE_Thunderstorm.copyToClipboard(actionName), children: actionName })
                        },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(DefaultEditor_InputText, { type: 'text', placeholder: 'Enter order Name', editable: this.state.editable, value: action.item.name, prop: 'name', showErrorTooltip: true, onChange: async (value) => {
                                    await action.updateObj({ name: value });
                                } })
                        }
                    ] })] });
    };
    renderOrderId = () => {
        const action = this.state.editable;
        const actionId = action.item._id ?? '-';
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Order Id" }), _jsx(DataGrid.Data, { onClick: () => ModuleFE_Thunderstorm.copyToClipboard(actionId), children: actionId })] });
    };
    renderLabel = () => {
        const action = this.state.editable;
        const actionLabel = action.item.label ?? '-';
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Order Label" }), _jsx(Component_SwitchView, { mode: this.getRenderKey(), modes: [
                        {
                            key: RenderKey_View,
                            renderer: () => _jsx(DataGrid.Data, { onClick: () => ModuleFE_Thunderstorm.copyToClipboard(actionLabel), children: actionLabel })
                        },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(DefaultEditor_InputText_Optional, { type: 'text', placeholder: 'Enter order label', editable: this.state.editable, value: action.item.label, prop: 'label', showErrorTooltip: true, onChange: async (value) => {
                                    await action.updateObj({ label: value });
                                } })
                        }
                    ] })] });
    };
    renderType = () => {
        const action = this.state.editable;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Type" }), _jsx(Component_SwitchView, { mode: this.getRenderKey(), modes: [
                        { key: RenderKey_View, renderer: () => _jsx(DataGrid.Data, { children: action.item.type }) },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(Dropdown_ActionType.editable, { editable: this.state.editable, prop: 'type', showErrorTooltip: true, onSelected: async (type) => {
                                    if (action.item.type === type)
                                        return;
                                    await action.updateObj({ type: type, subType: undefined });
                                    this.forceUpdate();
                                } })
                        },
                    ] })] });
    };
    renderSubType = () => {
        const action = this.state.editable;
        if (!action.item.type)
            return;
        const subTypes = ModuleFE_Action.is.order(action.item) ? ActionSubTypes_Order : ActionSubTypes_Interflow;
        const adapter = SimpleListAdapter([...subTypes], type => _jsx(_Fragment, { children: actionSubTypeLabelMap[type.item] }));
        const mandatoryProps_SubTypeDropdown = {
            adapter: adapter,
            caret: DropDown_DefaultCaret,
            placeholder: 'Choose resource type'
        };
        const Dropdown_Subtype = TS_DropDown.prepareEditable(mandatoryProps_SubTypeDropdown);
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Sub Type" }), _jsx(Component_SwitchView, { mode: this.getRenderKey(), modes: [
                        {
                            key: RenderKey_View, renderer: () => _jsx(DataGrid.Data, { children: actionSubTypeLabelMap[action.item.subType] })
                        },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(Dropdown_Subtype, { editable: this.state.editable, prop: 'subType', onSelected: async (subType) => {
                                    await action.updateObj({ subType });
                                }, showErrorTooltip: true })
                        },
                    ] })] });
    };
    renderData = () => {
        const action = this.state.editable;
        if (!action.item.type)
            return;
        switch (action.item.type) {
            case 'order': {
                return _jsx(Renderer_ActionData_Order, { editable: action, editMode: this.state.editMode });
            }
            default:
                return;
        }
    };
    renderTags = () => {
        const action = this.state.editable;
        const tagGroups = action.item.tagGroups;
        const uiTagGroups = VariableWrapper.dbTagsToUI(this.state.editable.get('tagGroups'));
        if (!tagGroups)
            return;
        return _jsxs(_Fragment, { children: [_jsx(DataGrid.Label, { children: "Tags" }), _jsx(Component_SwitchView, { mode: this.getRenderKey(), modes: [
                        {
                            key: RenderKey_View, renderer: () => _jsx(DataGrid.Data, { children: _jsx(Component_TagGroups, { tagGroups: tagGroups }) })
                        },
                        {
                            key: RenderKey_Edit,
                            renderer: () => _jsx(Component_TagEditor, { tags: uiTagGroups, mandatoryRootTag: true, groupTagFilter: () => true, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id, onChange: async () => {
                                    const tagGroups = VariableWrapper.getTagsForDB(uiTagGroups);
                                    await this.state.editable.updateObj({ tagGroups });
                                } })
                        },
                    ] })] });
    };
}
//# sourceMappingURL=OrderItem_EditorRenderer.js.map